// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"aa98c29e","294":"e4d14baa"}[chunkId] + ".chunk.js";
};